<template>
  <div class="row">
    <div v-if="files.length > 1" class="col-lg-4 mb-3">
      <training-files-list
        :files="files"
        :selected-id="selectedFile ? selectedFile.id : null"
        :numbered="numbered"
        @select="selectedFile = $event"
      />
    </div>
    <div :class="files.length > 1 ? 'col-lg-8' : 'col-12'">
      <template v-if="selectedFile">
        <div
          class="d-flex flex-wrap align-items-center justify-content-between mb-2"
        >
          <h4 class="mb-2 mr-2 text-break">{{ selectedFile.name }}</h4>
          <training-seen-button :file="selectedFile" class="mb-2" />
        </div>
        <training-file-viewer :file="selectedFile" />
      </template>
      <p v-else class="text-muted">{{ $t("TRAININGS.NO_FILES") }}</p>
    </div>
  </div>
</template>

<script>
import TrainingFilesList from "./TrainingFilesList.vue";
import TrainingFileViewer from "./TrainingFileViewer.vue";
import TrainingSeenButton from "./TrainingSeenButton.vue";

/**
 * Liste des fichiers d'un sujet et lecteur du fichier choisi, avec la case
 * « vu ». Sert la fenêtre d'aide et les pages qui l'affichent en ligne.
 */
export default {
  name: "training-files-panel",

  components: { TrainingFilesList, TrainingFileViewer, TrainingSeenButton },

  props: {
    files: {
      type: Array,
      default: () => [],
    },
    initialFileId: {
      type: Number,
      default: null,
    },
    numbered: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selectedFile: null,
    };
  },

  watch: {
    files: {
      handler(files) {
        if (this.selectedFile && files.includes(this.selectedFile)) {
          return;
        }
        this.selectedFile =
          files.find((file) => file.id === this.initialFileId) ||
          files[0] ||
          null;
      },
      immediate: true,
    },
  },
};
</script>
